import { render, staticRenderFns } from "./salesPackage.vue?vue&type=template&id=572f3d26"
import script from "./salesPackage.vue?vue&type=script&lang=js"
export * from "./salesPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports